import chroma from "chroma-js";
import { DataDivisionType, LayerInfo } from "src/common/managers/Types";
import { DataCollector } from "src/dataCollector/DataCollector";
import { GenerateGeomUtils } from "src/managers/GenerateGeomUtils";
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";

export type SFEColorEntry = {
   sfe: number;
   color: string;
};

export type ServitutRapportBfeData = {
   BFEnummer: number;
   adresse: string;
   servitutter?: any[];
   stamOplysninger?: any;
   [key: string]: any;
};

export async function hentServitutData(liste: { sfe: number }[]) {
   return Promise.all(liste.map(async (a) => {
      return await PropertyInfoInterface.getDataTingbogByBFE(a.sfe.toString());
   }));
}

export async function hentBeliggenhed(liste: { sfe: number }[]) {
   let request = liste.map((a) => a.sfe.toString());
   let EBR = await DataCollector.DF_GQL.EBR.EBRAdresseOgPunkt(request);
   return EBR.map((a) => a.betegnelse);
}

export async function hentServitutDataOgBeliggenhed(liste: { sfe: number }[]): Promise<ServitutRapportBfeData[]> {
   let data = await hentServitutData(liste);
   let adresser = await hentBeliggenhed(liste);
   return data.map((item, idx) => ({ ...item, adresse: adresser[idx], BFEnummer: liste[idx].sfe }));
}

export function SFEAndColorList(layerInfoArr: LayerInfo[]): SFEColorEntry[] {
   let list: SFEColorEntry[] = [];
   let sfeList = new Set<number>();
   let validLayers = layerInfoArr.filter(layer => layer.propertiesInGeoJson?.includes("SFEnummer"));

   validLayers.forEach(layer => {
      let getColor = (_p) => layer.styling.color && chroma(layer.styling.color).hex("rgb") || "black";
      if (layer.styling.colorByProperty) {
         if (layer.styling.colorByValue?.divisions?.type == DataDivisionType.Discrete) {
            let style = layer.styling;
            getColor = (properties) => {
               if (style.colorByProperty) {
                  let x = GenerateGeomUtils.getColorByValueDiscrete(undefined as any, properties[style.colorByProperty], style.colorByValue?.divisions, style.outsideColorRange);
                  return x.color && chroma(x.color).hex("rgb") || "black";
               }
               return "black";
            };
         } else if (layer.styling.colorByValue?.divisions?.type == DataDivisionType.Continous) {
            let style = layer.styling;
            getColor = (properties) => {
               if (style.colorByProperty) {
                  let x = GenerateGeomUtils.getColorByValueNummeric(undefined as any, properties[style.colorByProperty], style.colorByValue?.divisions, style.outsideColorRange);
                  return x.color && chroma(x.color).hex("rgb") || "black";
               }
               return "black";
            };
         }
      }
      layer.geoJson?.features?.forEach(feature => {
         let sfe = feature.properties?.SFEnummer;
         if (sfe && typeof sfe === "string") {
            sfe = parseInt(sfe);
         }
         if (sfe && !sfeList.has(sfe)) {
            sfeList.add(sfe);
            list.push({ sfe: sfe, color: getColor(feature.properties) });
         }
      });
   });
   return list;
}
